/** Routes inside the apps/lk personal-account SPA, mirroring its own AppEndpoint enum. */
export enum LkLinks {
    ORDERS = '',
    SETTINGS = '/settings',
}
